import { SystemService } from './../service/system.service';
import { NotificationService } from '../service/notification.service';
import { BLocalStorageService } from '../service/bLocalStorage.service';
import { BTokenService } from '../service/bToken.service';
var LayoutComponent = (function () {
    function LayoutComponent(notificationService) {
        this.notificationService = notificationService;
        // this.notificationService.enableNotification();
        this.bLocalStorageService = new BLocalStorageService();
        this.bTokenService = new BTokenService();
        this.systemS = new SystemService();
    }
    LayoutComponent.prototype.ngOnInit = function () {
        if (this.bLocalStorageService.getValue('accessToken')) {
            this.bTokenService.updateSessionStorage();
        }
    };
    return LayoutComponent;
}());
export { LayoutComponent };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/layout/layout.component.ts.pre-build-optimizer.js